import { render, staticRenderFns } from "./ConfigTabContasBloqueadas.vue?vue&type=template&id=a76c85c8&scoped=true"
import script from "./ConfigTabContasBloqueadas.vue?vue&type=script&lang=js"
export * from "./ConfigTabContasBloqueadas.vue?vue&type=script&lang=js"
import style0 from "./ConfigTabContasBloqueadas.vue?vue&type=style&index=0&id=a76c85c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76c85c8",
  null
  
)

export default component.exports